import Button from './button';

export default class Primary extends Button {
  get buttonVariant() {
    return 'primary';
  }
}
